import ConceptList from "Explore/Pages/ConceptList/ConceptList";
import ConceptDetail from "Explore/Pages/ConceptDetail/ConceptDetail";
import FacultyDetail from "Explore/Pages/FacultyDetail/FacultyDetail";
import FacultyList from "Explore/Pages/FacultyList/FacultyList";
import Benchmarking from "Explore/Pages/Benchmarking/Benchmarking";
import KeywordBenchmark from "Explore/Pages/KeywordBenchmark/KeywordBenchmark";
import LandingBenchmark from "Explore/Pages/LandingBenchmark/LandingBenchmark";
import Home from "Explore/Pages/Home/Home";
import InstitutionDetail from "Explore/Pages/InstitutionDetail/InstitutionDetail";
import InstitutionList from "Explore/Pages/InstitutionList/InstitutionList";
import VenueDetail from "Explore/Pages/VenueDetail/VenueDetail";
import VenueList from "Explore/Pages/VenueList/VenueList";
import UnitList from "Explore/Pages/UnitList/UnitList";
import UnitDetail from "Explore/Pages/UnitDetail";
import USER_TYPE_CONFIG from "Explore/Config/userTypeConfig";
import LoginRequiredSection from "Explore/Components/LoginRequired";
import Overview from "Explore/Pages/Overview/Overview";
import Collaborations from "Explore/Pages/Collaborations/Collaborations";
import MyLibrary from "Explore/Pages/MyLibrary/MyLibrary";
import Assistant from "Explore/Pages/Assistant/Assistant";
import Analysis from "Explore/Pages/Analysis/Analysis";
import AnalysisEntityDetail from "Explore/Pages/Analysis/AnalysisEntityDetail/AnalysisEntityDetail";
import Peer from "Explore/Pages/Peer/Peer";
import ReportDetail from "Explore/Pages/ReportDetail/ReportDetail";
import Settings from "Explore/Pages/Settings/Settings";
import Help from "Explore/Pages/Help/Help";
import McpServer from "Explore/Pages/McpServer/McpServer";

export const _routes = ({ userRole }) => {
  let routes = [
    {
      path: "/assistant",
      exact: true,
      component: Assistant,
      name: "Assistant",
      permissions: [],
    },
    {
      path: "/",
      exact: true,
      component: Home,
      name: "Home",
      permissions: [],
    },
    {
      path: "/overview",
      exact: true,
      component: userRole === USER_TYPE_CONFIG.USER_TYPE.SUBSCRIBED ? Overview : LoginRequiredSection,
      name: "Overview",
      permissions: [],
    },
    {
      path: "/collaborations",
      exact: true,
      component: userRole === USER_TYPE_CONFIG.USER_TYPE.SUBSCRIBED ? Collaborations : LoginRequiredSection,
      name: "Collaborations",
      permissions: [],
    },
    {
      path: "/my-library",
      exact: true,
      component: userRole === USER_TYPE_CONFIG.USER_TYPE.SUBSCRIBED ? MyLibrary : LoginRequiredSection,
      name: "My Library",
      permissions: [],
    },
    {
      path: "/settings",
      exact: true,
      component: userRole === USER_TYPE_CONFIG.USER_TYPE.SUBSCRIBED ? Settings : LoginRequiredSection,
      name: "Settings",
      permissions: [],
    },
    {
      path: "/help",
      exact: true,
      component: userRole === USER_TYPE_CONFIG.USER_TYPE.SUBSCRIBED ? Help : LoginRequiredSection,
      name: "Get Help",
      permissions: [],
    },
    {
      path: "/mcp-server",
      exact: true,
      component: userRole === USER_TYPE_CONFIG.USER_TYPE.SUBSCRIBED ? McpServer : LoginRequiredSection,
      name: "MCP Server",
      permissions: [],
    },
    {
      path: "/mcp",
      exact: true,
      component: userRole === USER_TYPE_CONFIG.USER_TYPE.SUBSCRIBED ? McpServer : LoginRequiredSection,
      name: "MCP Server",
      permissions: [],
    },
    {
      path: "/faculties",
      exact: true,
      component: FacultyList,
      name: "Faculty List",
      permissions: [],
    },
    {
      path: "/admin/faculties",
      exact: true,
      component: FacultyList,
      name: "Faculty List",
      permissions: [],
    },
    {
      path: "/benchmarking",
      exact: true,
      component: Benchmarking,
      name: "Benchmarking",
      permissions: [],
    },
    {
      path: "/keyword-benchmarking",
      exact: true,
      component: KeywordBenchmark,
      name: "Keyword Benchmarking",
      permissions: [],
    },
    {
      path: "/analysis/:entityType/:entitySlug",
      exact: true,
      component: AnalysisEntityDetail,
      name: "Analysis Entity Detail",
      permissions: [],
    },
    {
      path: "/analysis",
      exact: true,
      component: Analysis,
      name: "Analysis",
      permissions: [],
    },
    {
      path: "/peer",
      exact: true,
      component: Peer,
      name: "Peer",
      permissions: [],
    },
    {
      path: "/report-detail",
      exact: true,
      component: ReportDetail,
      name: "Report Detail",
      permissions: [],
    },
    {
      path: "/faculties/:keyword",
      exact: true,
      component: FacultyList,
      name: "Faculty List",
      permissions: [],
    },
    {
      path: "/faculty/:id",
      exact: true,
      component: FacultyDetail,
      name: "Faculty Profile",
      permission: [],
    },
    {
      path: "/venues",
      exact: true,
      component: VenueList,
      name: "Venue list",
      permission: [],
    },
    {
      path: "/admin/venues",
      exact: true,
      component: VenueList,
      name: "Venue list",
      permission: [],
    },
    {
      path: "/venues/:keyword",
      exact: true,
      component: VenueList,
      name: "Venue list",
      permission: [],
    },
    {
      path: "/venue/:id",
      exact: true,
      component: VenueDetail,
      name: "Faculty Detail",
      permission: [],
    },
    {
      path: "/institutions",
      exact: true,
      component: InstitutionList,
      name: "Institution list",
      permission: [],
    },
    {
      path: "/admin/institutions",
      exact: true,
      component: InstitutionList,
      name: "Institution list",
      permission: [],
    },
    {
      path: "/institutions/:keyword",
      exact: true,
      component: InstitutionList,
      name: "Institution list",
      permission: [],
    },
    {
      path: "/institution/:id",
      exact: true,
      component: InstitutionDetail,
      name: "Faculty Detail",
      permission: [],
    },
    // {
    //   path: "/concepts",
    //   exact: true,
    //   component: ConceptList,
    //   name: "Concept list",
    //   permission: [],
    // },
    // {
    //   path: "/concept/:id",
    //   exact: true,
    //   component: ConceptDetail,
    //   name: "Concept Detail",
    //   permission: [],
    // },
    {
      path: "/units",
      exact: true,
      // component: USER_TYPE_CONFIG.UNIT[userRole]?.ui_components?.listView
      //   ? UnitList
      //   : LoginRequiredSection,
      component: UnitList,
      name: "Unit",
      permission: [],
    },
    {
      path: "/admin/units",
      exact: true,
      // component: USER_TYPE_CONFIG.UNIT[userRole]?.ui_components?.listView
      //   ? UnitList
      //   : LoginRequiredSection,
      component: UnitList,
      name: "Unit",
      permission: [],
    },
    {
      path: "/units/:keyword",
      exact: true,
      // component: USER_TYPE_CONFIG.UNIT[userRole]?.ui_components?.listView
      //   ? UnitList
      //   : LoginRequiredSection,
      component: UnitList,
      name: "Unit",
      permission: [],
    },
    {
      path: "/unit/:id",
      exact: true,
      // component: USER_TYPE_CONFIG.UNIT[userRole]?.ui_components?.listView
      //   ? UnitDetail
      //   : LoginRequiredSection,
      component: UnitDetail,
      name: "Unit Detail",
      permission: [],
    },
  ];
  return routes;
};
